// Variables que se actualizarán con los valores del config.config
let API_HOSTNAME_DOCUMENT_REQUEST = "";
let API_HOSTNAME_QR_REQUEST = "";

// Promesa para saber cuando el config está listo
let configReadyResolve;
const configReady = new Promise((resolve) => {
  configReadyResolve = resolve;
});

// Función para parsear el archivo .config (formato clave=valor)
const parseConfig = (text) => {
  const config = {};
  const lines = text.split("\n");

  for (const line of lines) {
    // Ignorar líneas vacías y comentarios
    const trimmedLine = line.trim();
    if (!trimmedLine || trimmedLine.startsWith("#")) {
      continue;
    }

    // Buscar el primer signo igual
    const equalIndex = trimmedLine.indexOf("=");
    if (equalIndex > 0) {
      const key = trimmedLine.substring(0, equalIndex).trim();
      const value = trimmedLine.substring(equalIndex + 1).trim();
      if (key && value) {
        config[key] = value;
      }
    }
  }

  return config;
};

// Función para cargar el config.config desde la carpeta public
const loadConfig = async () => {
  try {
    const response = await fetch("/src/config.config");
    if (response.ok) {
      const text = await response.text();
      const loadedConfig = parseConfig(text);

      if (loadedConfig.API_HOSTNAME_DOCUMENT_REQUEST) {
        API_HOSTNAME_DOCUMENT_REQUEST =
          loadedConfig.API_HOSTNAME_DOCUMENT_REQUEST;
      }
      if (loadedConfig.API_HOSTNAME_QR_REQUEST) {
        API_HOSTNAME_QR_REQUEST = loadedConfig.API_HOSTNAME_QR_REQUEST;
      }

      if (!API_HOSTNAME_DOCUMENT_REQUEST || !API_HOSTNAME_QR_REQUEST) {
        console.error("Error: Faltan valores requeridos en config.config");
      }
      configReadyResolve(true);
    } else {
      console.error(
        "Error: No se pudo cargar config.config. Verifique que el archivo existe."
      );
      configReadyResolve(false);
    }
  } catch (error) {
    console.error("Error al cargar config.config:", error);
    configReadyResolve(false);
  }
};

// Cargar el config inmediatamente
loadConfig();

// Exportar las constantes
// Nota: Al usar 'export let', los módulos que importen estas constantes
// obtendrán una referencia a la variable, por lo que verán los valores actualizados
// cuando el config se cargue (si se carga antes de usarse)
export { API_HOSTNAME_DOCUMENT_REQUEST, API_HOSTNAME_QR_REQUEST, configReady };

// Comentarios de URLs anteriores (referencia)
//export const API_HOSTNAME_DOCUMENT_REQUEST = 'http://qa.firmadigital.co/doc/documentmanager/api/DocumentManager';
//export const API_HOSTNAME_QR_REQUEST = 'https://ym9x2ku6x4.execute-api.us-east-2.amazonaws.com/dev/qrmanager/api/QR/consultardocumento';
//export const API_HOSTNAME_DOCUMENT_REQUEST = 'https://ym9x2ku6x4.execute-api.us-east-2.amazonaws.com/dev/documentmanager/api/DocumentManager';
//export const API_HOSTNAME_QR_REQUEST = 'https://8uw10ruhfj.execute-api.us-east-2.amazonaws.com/qa/qr/qrmanager/api/QR/consultardocumento';
//export const API_HOSTNAME_DOCUMENT_REQUEST = 'https://8uw10ruhfj.execute-api.us-east-2.amazonaws.com/qa/doc/documentmanager/api/DocumentManager';
